import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  ButtonBase,
  IconButton,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PromptLibraryItem } from '../../../../store/one-query/promptLibrarySlice';
import { useAppSelector } from '../../../../store/hooks';
import { AcademicCatIcon } from '../../../../Custom-imeges/Prompt-library-icons/AcademicCatIcon';
import { FinanceCatIcon } from '../../../../Custom-imeges/Prompt-library-icons/FinanceCatIcon';
import { DeveloperCatIcon } from '../../../../Custom-imeges/Prompt-library-icons/DeveloperCatIcon';
import { MarketingCatIcon } from '../../../../Custom-imeges/Prompt-library-icons/MarketingCatIcon';
import { PersonalCatIcon } from '../../../../Custom-imeges/Prompt-library-icons/PersonalCatIcon';
import PersonalDevelopmentIcon from '../../../../Custom-imeges/Prompt-library-icons/PersonalDevelopmentIcon';
import CareerDevelopmentIcon from '../../../../Custom-imeges/Prompt-library-icons/CareerDevelopmentIcon';
import FinanceIcon from '../../../../Custom-imeges/Prompt-library-icons/FinanceIcon';
import AdvancedFinanceIcon from '../../../../Custom-imeges/Prompt-library-icons/AdvancedFinanceIcon';
import ProfessorsIcon from '../../../../Custom-imeges/Prompt-library-icons/ProfessorsIcon';
import RetailbusinessIcon from '../../../../Custom-imeges/Prompt-library-icons/RetailbusinessIcon';
import PRCommunicationIcon from '../../../../Custom-imeges/Prompt-library-icons/PR&CommunicationIcon';
import FitnessIcon from '../../../../Custom-imeges/Prompt-library-icons/FitnessIcon';
import LanguageLearningIcon from '../../../../Custom-imeges/Prompt-library-icons/LanguageLearning';

interface PromptLibraryCategoryProps {
  prompt: PromptLibraryItem,
  panelId: string;
  activeSubtype:string;
  expandedPanel: string | false;
  setActiveSubtype: (subtitle:string) => void;
  setExpandedPanel: (panel: string | false) => void;
  setPromptContent: (promptContent:PromptLibraryItem[]) => void;
}

export const PromptLibraryCategory = ({
  prompt,
  panelId,
  expandedPanel,
  setExpandedPanel,
  setPromptContent,
  setActiveSubtype,
  activeSubtype
}: PromptLibraryCategoryProps) => {
  const [promptSubtypes,setPromptSubtypes] = useState<PromptLibraryItem[]>([])
  const promptLibrary = useAppSelector((s) => s.PromptLibrary.promptLibraryItems);
  const User = useAppSelector((s) => s.User);

  // Make only one type open.
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedPanel(isExpanded ? panel : false);
  };

  // Method to return subtypes without duplicates.
  const getPromptSubtypes = (type:string) => {
    let uniquePromptSubtypes = Array.from(
      new Map(
        promptLibrary
          .filter((pro) => pro.type === type)
          .map((pro) => [pro.subType, pro])
      ).values()
    );
    setPromptSubtypes(uniquePromptSubtypes);
  };

  // Method to return subtype content.
  const getPromptContent = (subtype:string) => {
    let subtypeContent = promptLibrary.filter((pro) => pro.subType === subtype);
    setPromptContent(subtypeContent)
  };

  const handleSubtypeClick = (itemSubtype:string , itemId:string) => {
    getPromptContent(itemSubtype)
    setActiveSubtype(itemId)
  }

  useEffect(()=> {
    if(expandedPanel !== panelId){
      setActiveSubtype('');
    }
  },[expandedPanel,panelId])

  const PromptIcons = {
    'personal development': ()  => <PersonalDevelopmentIcon/>,
    'developer':()  => <DeveloperCatIcon/>,
    'marketing':()  => <MarketingCatIcon/>,
    'career development':  ()  => <CareerDevelopmentIcon/>,
    'finance': ()  => <FinanceIcon/>,
    'advanced finance': ()  => <AdvancedFinanceIcon/>,
    'professors': ()  => <ProfessorsIcon/>,
    'retail business': ()  => <RetailbusinessIcon/>,
    'pr & communications': ()  => <PRCommunicationIcon/>,
    'fitness': ()  => <FitnessIcon/>,
    'language learning': ()  => <LanguageLearningIcon/>,
  }

  const isPromptType = (type: string): type is keyof typeof PromptIcons => {
  return type in PromptIcons;
};

  return (
    <Accordion
      className="prompt-library-category"
      sx={{
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
        '&::before': { display: 'none' },
      }}
      expanded={expandedPanel === panelId}
      onChange={handleChange(panelId)}
      onClick={() => getPromptSubtypes(prompt.type)}
    >
      <AccordionSummary
        className={`${expandedPanel === panelId && 'active'}`}
        expandIcon={<ExpandMoreIcon sx={{color: expandedPanel === panelId ? '#10B0E8' : User.darkMode ? '#fff' : '#0B1216' }} />}
        aria-controls={`${panelId}-content`}
        id={`${panelId}-header`}
        sx={{
          margin: '0',
          height: '36px',
          minHeight: '36px',
          '&.Mui-expanded': {
            height: '36px',
            minHeight: '36px',
          },
        }}
      >
        <Box className="category-header">
          <ButtonBase className={`category-icon ${expandedPanel === panelId && 'active-prompt-icon'}`}
            sx={{
              mx: '8px',
            }}
          >
            {isPromptType(prompt.type.trim().toLowerCase()) ? PromptIcons[prompt.type.trim().toLowerCase() as keyof typeof PromptIcons]() : null}
          </ButtonBase>
          <Typography className="category-name">{prompt.type}</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails className="category-items" sx={{padding:"0"}}>
        {promptSubtypes.map((pro) => (
          <Typography key={pro.id} className={`category-item ${pro.id === activeSubtype && "active"}`} sx={{fontSize:"12px",}} 
            onClick={() => handleSubtypeClick(pro.subType,pro.id)}>
            {pro.subType}
          </Typography>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
